// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let ReactDatepicker = require("../../../uikit/atoms/Datepicker/ReactDatepicker.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
let PropertyWizardRelayShowingsShowing_draft_graphql = require("../../../__generated__/PropertyWizardRelayShowingsShowing_draft_graphql.bs.js");
let PropertyWizardRelayShowingsShowing_showing_graphql = require("../../../__generated__/PropertyWizardRelayShowingsShowing_showing_graphql.bs.js");

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return x.value;
}

let Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function makeOption(value) {
  let tmp;
  switch (value) {
    case "AGENTS_ONLY" :
      tmp = "Agents only";
      break;
    case "BUYERS_WELCOME" :
      tmp = "Buyers welcome";
      break;
    case "TAN_ONLY" :
      tmp = "TAN only";
      break;
  }
  return {
    value: value,
    label: tmp
  };
}

let options = [
  "TAN_ONLY",
  "AGENTS_ONLY",
  "BUYERS_WELCOME"
].map(makeOption);

function PropertyWizardRelay__Showings__Showing$ShowingTypeInputField(props) {
  let onChange = props.onChange;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Showing type"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: getOptionLabel,
        getOptionValue: getOptionValue,
        isClearable: true,
        onChange: value => onChange(Stdlib_Option.map(value, param => param.value)),
        options: options,
        placeholder: "Showing type",
        value: Stdlib_Option.map(props.value, makeOption)
      })
    ]
  });
}

let ShowingTypeInputField = {
  Option: Option,
  makeOption: makeOption,
  options: options,
  make: PropertyWizardRelay__Showings__Showing$ShowingTypeInputField
};

let convertFragment = PropertyWizardRelayShowingsShowing_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, fRef);
}

let ShowingFragment_showingTypeV5_decode = PropertyWizardRelayShowingsShowing_showing_graphql.Utils.showingTypeV5_decode;

let ShowingFragment_showingTypeV5_fromString = PropertyWizardRelayShowingsShowing_showing_graphql.Utils.showingTypeV5_fromString;

let ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayShowingsShowing_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Showings__Showing(props) {
  let showingNum = props.showingNum;
  let showing = RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowingsShowing_showing_graphql.node, convertFragment, props.showing);
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayShowingsShowing_draft_graphql.node, convertFragment$1, props.draft);
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let typProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "Showing",
    showingNum: showingNum,
    updater: (dp, value) => ({
      date: dp.date,
      endTime: dp.endTime,
      id: dp.id,
      key: dp.key,
      notes: dp.notes,
      startTime: dp.startTime,
      type_: value
    })
  }, true, showing.type_, PropertyWizardFormRelay__Validators__Showings.Showing.Type.useIsValid(showing.fragmentRefs));
  let startTimeProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "Showing",
    showingNum: showingNum,
    updater: (dp, value) => ({
      date: dp.date,
      endTime: dp.endTime,
      id: dp.id,
      key: dp.key,
      notes: dp.notes,
      startTime: value,
      type_: dp.type_
    })
  }, true, showing.startTime, PropertyWizardFormRelay__Validators__Showings.Showing.StartTime.useIsValid(showing.fragmentRefs));
  let endTimeProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "Showing",
    showingNum: showingNum,
    updater: (dp, value) => ({
      date: dp.date,
      endTime: value,
      id: dp.id,
      key: dp.key,
      notes: dp.notes,
      startTime: dp.startTime,
      type_: dp.type_
    })
  }, true, showing.endTime, PropertyWizardFormRelay__Validators__Showings.Showing.EndTime.useIsValid(showing.fragmentRefs));
  let dateProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "Showing",
    showingNum: showingNum,
    updater: (dp, value) => ({
      date: value,
      endTime: dp.endTime,
      id: dp.id,
      key: dp.key,
      notes: dp.notes,
      startTime: dp.startTime,
      type_: dp.type_
    })
  }, true, showing.date, PropertyWizardFormRelay__Validators__Showings.Showing.$$Date.useIsValid(showing.fragmentRefs, draft.fragmentRefs));
  let notesProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "Showing",
    showingNum: showingNum,
    updater: (dp, value) => ({
      date: dp.date,
      endTime: dp.endTime,
      id: dp.id,
      key: dp.key,
      notes: value,
      startTime: dp.startTime,
      type_: dp.type_
    })
  }, true, showing.notes, PropertyWizardFormRelay__Validators__Showings.Showing.Notes.useIsValid());
  let showFieldValidations = Stdlib_Option.isSome(typProps.value) || Stdlib_Option.isSome(startTimeProps.value) || Stdlib_Option.isSome(endTimeProps.value) || Stdlib_Option.isSome(dateProps.value);
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
      children: [
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          widthMd: 3,
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Date"
            }),
            JsxRuntime.jsx(ReactDatepicker.make, {
              placeholderText: "Showing date",
              onChange: date => dateProps.onChange(date),
              selected: dateProps.value,
              minDate: Primitive_option.some(CalendarDate.today(DateFnsTz.Timezone.make(draft.timeZone)))
            }),
            showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: dateProps.valid
              }) : null
          ]
        }),
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 6,
          widthMd: 3,
          children: [
            JsxRuntime.jsx(PropertyWizardFormRelay__Elements.TimePicker.make, {
              value: PropertyWizardRelayUtils.FormUtils.decodeTime(startTimeProps.value),
              onChange: time => startTimeProps.onChange(Stdlib_Option.map(time, Types__Time.encode)),
              label: "Start time",
              placeholder: "Start time",
              startTime: 9,
              isClearable: true,
              endTime: 21,
              hourlyIntervals: 2
            }),
            showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: startTimeProps.valid
              }) : null
          ]
        }),
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 6,
          widthMd: 3,
          children: [
            JsxRuntime.jsx(PropertyWizardFormRelay__Elements.TimePicker.make, {
              value: PropertyWizardRelayUtils.FormUtils.decodeTime(endTimeProps.value),
              onChange: time => endTimeProps.onChange(Stdlib_Option.map(time, Types__Time.encode)),
              label: "End time",
              placeholder: "End time",
              startTime: 10,
              isClearable: true,
              endTime: 22,
              hourlyIntervals: 2
            }),
            showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: endTimeProps.valid
              }) : null
          ]
        }),
        JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          widthMd: 3,
          children: [
            JsxRuntime.jsx(PropertyWizardRelay__Showings__Showing$ShowingTypeInputField, {
              value: typProps.value,
              onChange: v => typProps.onChange(v)
            }),
            showFieldValidations ? JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: typProps.valid
              }) : null
          ]
        }),
        JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          children: JsxRuntime.jsx(Form__TextAreaField.make, {
            labelText: "Notes",
            optionalText: "optional",
            onChange: e => notesProps.onChange(e.target.value),
            value: notesProps.value
          })
        }),
        JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
          width: 12,
          children: JsxRuntime.jsx(View__Jsx3.make, {
            justifyContent: "flexEnd",
            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => updateDraftProperty(localDraftProperty => {
                let showings = localDraftProperty.showings.slice();
                showings.splice(showingNum, 1);
                let newrecord = {...localDraftProperty};
                newrecord.showings = showings;
                return newrecord;
              }),
              children: "Remove showing"
            })
          })
        })
      ]
    })
  });
}

let Components;

let FormSection;

let Validators;

let FormUtils;

let Form;

let Cell;

let Grid;

let Elements;

let make = PropertyWizardRelay__Showings__Showing;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Form = Form;
exports.Cell = Cell;
exports.Grid = Grid;
exports.Elements = Elements;
exports.ShowingTypeInputField = ShowingTypeInputField;
exports.ShowingFragment = ShowingFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* options Not a pure module */
